import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import SearchContext from '~/context/srp/SearchContext';
import useIsFromSearchBar from '~/hooks/srp/useIsFromSearchBar';

export default function useRegenerateSearchSessionId() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { regenerateSearchSessionId } = useContext(SearchContext);
  const isFromSearchBar = useIsFromSearchBar();

  // If applied filters changed and now none exist, or filters come from search bar, start a new search session
  useSubsequentEffect(() => {
    if (Object.keys(appliedFilters).length === 0 || isFromSearchBar) {
      regenerateSearchSessionId();
    }
  }, [appliedFilters, isFromSearchBar, regenerateSearchSessionId]);
}
